import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    creditors: [],
  },
  mutations: {
    setCreditors(state, creditors) {
      Vue.set(state, 'creditors', creditors);
    },
  },
  actions: {
    fetchCreditors({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/creditors`).then(response => {
        return commit('setCreditors', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};